import { render, staticRenderFns } from "./PaperEditor.vue?vue&type=template&id=d5eb2624&scoped=true"
import script from "./PaperEditor.vue?vue&type=script&lang=js"
export * from "./PaperEditor.vue?vue&type=script&lang=js"
import style0 from "./PaperEditor.vue?vue&type=style&index=0&id=d5eb2624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5eb2624",
  null
  
)

export default component.exports